import { createApp } from 'vue'
import '@/style.css'
import App from '@/App.vue'
import i18n from '@/i18n'

try {
    const response = await fetch('/icons.svg')
    if (response.ok) {
        const data = await response.text()
        document.body.insertAdjacentHTML('afterbegin', data)
    }
} catch {}

createApp(App).use(i18n).mount('#app')
